import {
    useGetFrontendUrlQuery,
    useGetUnpostedMinutesQuery,
    useIsTiqTimeEnabledQuery,
} from 'store/api/tiq-time-integration';

const formatMinutesToHHMM = (minutes: number): string => {
    const hours = Math.floor(minutes / 60);
    const remainingMinutes = minutes % 60;
    const hourString = hours < 10 ? hours.toString() : hours.toString().padStart(2, '0');
    return `${hourString},${remainingMinutes.toString().padStart(2, '0')}`;
};

export const useTiqTime = () => {
    const { data: isEnabled } = useIsTiqTimeEnabledQuery();
    const { data: unPostedMinutes } = useGetUnpostedMinutesQuery(undefined, { skip: !isEnabled });
    const { data: frontendUrl } = useGetFrontendUrlQuery(undefined, { skip: !isEnabled });

    return {
        isEnabled,
        unPostedMinutes,
        unPostedMinutesFormatted: formatMinutesToHHMM(unPostedMinutes || 0),
        frontendUrl,
    };
};
